import { fetchContentBySlug } from '@/services/content'

const SITE_SETTINGS_SLUG = 'site'
const SITE_SETTINGS_LOCALE = 'fr'

const isRecord = value => value && typeof value === 'object' && !Array.isArray(value)

export async function fetchSiteSettings () {
  try {
    const res = await fetchContentBySlug(SITE_SETTINGS_SLUG, SITE_SETTINGS_LOCALE)
    const data = res?.data
    if (!data || data.type !== 'settings') return null
    const meta = isRecord(data.meta) ? data.meta : null
    const social = meta && isRecord(meta.social) ? meta.social : {}
    return { social }
  } catch {
    return null
  }
}
